import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import CommonToast from "../../../components/_utils/CommonToast";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import ICONS from "../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const reimbursementRequestViewAll = createAsyncThunk(
  "reimbursementRequest/viewAll",
  async (values = {}, { rejectWithValue }) => {
    try {
      const {
        page_no,
        page_item_count,
        lifecycle_status,
        category,
        start_date,
        end_date,
        search_string,
        beneficiary_account_id,
        owner_account_id,
        txn_id,
        request_amount,
        reimbursement_amount,
        entity_id,
        category_name,
        category_value,
        category_label,
        labels,
        additional_data,
        payment_method,
      } = values;

      const response = await axiosInstance.get(
        `${baseUrl}/requests/reimbursement`,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            "page_size": page_item_count,
            lifecycle_status,
            category,
            start_date,
            end_date,
            search_string,
            txn_id,
            "owner_account_id[]": owner_account_id,
            "beneficiary_account_id[]": beneficiary_account_id,
            request_amount,
            reimbursement_amount,
            entity_id,
            category_label,
            category_name,
            category_value,
            additional_data,
            labels,
            payment_method,
          },
        },
      );
      return response.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,

        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const reimbursementRequestApproval = createAsyncThunk(
  "reimbursementRequest",
  async (values, { rejectWithValue }) => {
    const { page_no, page_size, category, entityId, labels } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/requests/reimbursement/actionable`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size,
            category,
            entity_id: entityId,
            labels,
          },
        },
      );

      const apiData = response.data;

      // 🔥 Normalize response
      // const normalized = {
      //   ...api,
      //   transactions: api.requests || [],
      //   summary: {
      //     available_labels:
      //       api.requests?.flatMap((r) => r.labels || []).filter(Boolean) || [],
      //   },
      // };

      return apiData;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const ReimbursementRequestDeniedApproval = createAsyncThunk(
  "ReimbursementRequestDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        request_ids: id,
        rejection_reason: AccountIdData,
      };

      if (Array.isArray(id)) {
        data.request_ids = id;
      } else {
        data.request_ids = [id];
      }

      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const ReimbursementRequestWaitingApproval = createAsyncThunk(
  "ReimbursementRequestWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: [id],
      };

      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const reimbursementRequestDetails = createAsyncThunk(
  "reimbursementRequestDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/requests/reimbursement/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("error", error);
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const addNewLabelRequest = createAsyncThunk(
  "addNewLabelRequest",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();
      CommonToast({
        text: "Label assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      // if (response?.data?.status) {
      //   let data =
      //     JSON.parse(sessionStorage.getItem("AvailableLabelsRequest")) || [];
      //   data = [...data, ...labels];
      //   sessionStorage.setItem(
      //     "AvailableLabelsRequest",
      //     JSON.stringify(data || []),
      //   );
      // }

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsRequest") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsRequest", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const removeNewLabelRequest = createAsyncThunk(
  "removeNewLabelRequest",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      CommonToast({
        text: "Label unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",

        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      // if (response?.data?.status) {
      //   let data =
      //     JSON.parse(sessionStorage.getItem("AvailableLabelsRequest")) || [];
      //   data = [...data, ...labels];
      //   sessionStorage.setItem(
      //     "AvailableLabelsRequest",
      //     JSON.stringify(data || []),
      //   );
      // }

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const requestTxnReject = createAsyncThunk(
  "requestTxnReject",
  async ({ request_ids, AccountIdData }, { rejectWithValue }) => {
    try {
      const data = {
        request_ids,
        rejection_reason: AccountIdData,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.data?.status === false || response.status >= 400) {
        return rejectWithValue(response.data);
      }
      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response ?? "An error occurred");
    }
  },
);
const reimbursementRequest = createSlice({
  name: "reimbursementRequest",
  initialState: {
    reimbursementRequestViewAllData: null,
    reimbursementRequestViewAllLoading: false,
    reimbursementRequestViewAllError: false,

    reimbursementRequestApprovalData: null,
    reimbursementRequestApprovalLoading: false,
    reimbursementRequestApprovalError: false,

    addLabelsRequestLoading: false,
    addLabelsRequestError: false,
    addLabelsRequestData: [],

    removeLabelsRequestLoading: false,
    removeLabelsRequestError: false,
    removeLabelsRequestData: [],

    reimbursementRequestDetailsData: null,
    reimbursementRequestDetailsLoading: false,
    reimbursementRequestDetailsError: false,

    requestTxnRejectLoading: false,
    requestTxnRejectError: null,
    requestTxnRejectData: [],

    ReimbursementMultiRequestWaitingApprovalData: null,
    ReimbursementMultiRequestDashBoardLoading: null,
    ReimbursementMultiRequestWaitingApprovalError: null,

    ReimbursementMultiRequestDeniedApprovalData: null,
    ReimbursementMultiRequestDeniedApprovalLoading: null,
    ReimbursementMultiRequestDeniedApprovalError: null,
    totalCount: 0,
    summary: {},

    storedPage: 1,
    isApprovalStatusSelected: false,
    toggle: false,
  },

  reducers: {
    setToggle(state, action) {
      state.toggle = action.payload;
    },
    resetToggle(state) {
      state.toggle = false;
    },
    setStoredPage(state, action) {
      state.storedPage = action.payload;
    },
    resetPage(state) {
      state.storedPage = 1;
    },
    setIsApprovalStatusSelected(state, action) {
      state.isApprovalStatusSelected = action.payload;
    },
    clearrequestTxnError: (state) => {
      state.requestTxnRejectError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reimbursementRequestViewAll.pending, (state) => {
        state.reimbursementRequestViewAllLoading = true;
        state.reimbursementRequestViewAllError = false;
      })
      .addCase(reimbursementRequestViewAll.fulfilled, (state, action) => {
        const payload = action.payload;

        state.reimbursementRequestViewAllLoading = false;
        state.reimbursementRequestViewAllData = payload;
        state.totalCount = payload?.total_count || 0;
        state.summary = payload?.summary || {};
        if (payload?.summary?.available_labels) {
          sessionStorage.setItem(
            "AvailableLabelsRequest",
            JSON.stringify(payload?.summary?.available_labels || []),
          );
        }
      })
      .addCase(reimbursementRequestViewAll.rejected, (state) => {
        state.reimbursementRequestViewAllLoading = false;
        state.reimbursementRequestViewAllError = true;
        state.reimbursementRequestViewAllData = null;
        state.totalCount = 0;
        state.summary = {};
      });

    builder
      .addCase(reimbursementRequestApproval.pending, (state) => {
        state.reimbursementRequestApprovalLoading = true;
        state.reimbursementRequestApprovalError = null;
      })

      .addCase(reimbursementRequestApproval.fulfilled, (state, action) => {
        const payload = action.payload;

        state.reimbursementRequestApprovalLoading = false;
        state.reimbursementRequestApprovalError = null;
        state.reimbursementRequestApprovalData = payload;

        // state.totalCount = payload?.total_count || 0;
        // state.summary = payload?.summary || {};
        // if (payload?.summary?.available_labels) {
        //   sessionStorage.setItem(
        //     "AvailableLabelsRequest",
        //     JSON.stringify(payload?.summary?.available_labels || []),
        //   );
        // }
      })

      .addCase(reimbursementRequestApproval.rejected, (state, action) => {
        state.reimbursementRequestApprovalLoading = false;
        state.reimbursementRequestApprovalError =
          action.payload?.error || action.payload?.message;

        state.reimbursementRequestApprovalData = null;
        state.totalCount = 0;
        state.summary = {};
        CommonToast({
          text: state.reimbursementRequestApprovalError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      });

    builder.addCase(addNewLabelRequest.pending, (state, action) => {
      state.addLabelsRequestLoading = true;
    });
    builder.addCase(addNewLabelRequest.fulfilled, (state, action) => {
      state.addLabelsRequestLoading = false;
      state.addLabelsRequestData = action.payload;
    });
    builder.addCase(addNewLabelRequest.rejected, (state, action) => {
      state.addLabelsRequestLoading = false;
      state.addLabelsRequestError = action.payload;
      state.addLabelsRequestData = null;
    });
    builder.addCase(removeNewLabelRequest.pending, (state, action) => {
      state.removeLabelsRequestLoading = true;
    });
    builder.addCase(removeNewLabelRequest.fulfilled, (state, action) => {
      state.removeLabelsRequestLoading = false;
      state.removeLabelsRequestData = action.payload;
    });
    builder.addCase(removeNewLabelRequest.rejected, (state, action) => {
      state.removeLabelsRequestLoading = false;
      state.removeLabelsRequestError = action.payload;
      state.removeLabelsRequestData = null;
    });

    builder
      .addCase(reimbursementRequestDetails.pending, (state) => {
        state.reimbursementRequestDetailsLoading = true;
        state.reimbursementRequestDetailsError = null;
      })

      .addCase(reimbursementRequestDetails.fulfilled, (state, action) => {
        const payload = action.payload;

        state.reimbursementRequestDetailsLoading = false;
        state.reimbursementRequestDetailsError = null;
        state.reimbursementRequestDetailsData = payload;

        // sessionStorage.setItem(
        //   "AvailableLabelsTxn",
        //   JSON.stringify(state.availableLabels),
        // );
      })

      .addCase(reimbursementRequestDetails.rejected, (state, action) => {
        state.reimbursementRequestDetailsLoading = false;
        state.reimbursementRequestDetailsError =
          action.payload?.error || action.payload?.message;
        console.log(
          state.reimbursementRequestDetailsError,
          "reimbursementRequestDetailsError",
        );
        CommonToast({
          text: state.reimbursementRequestDetailsError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      });

    builder
      .addCase(requestTxnReject.pending, (state) => {
        state.requestTxnRejectLoading = true;
        state.requestTxnRejectError = null;
      })

      .addCase(requestTxnReject.fulfilled, (state, action) => {
        const payload = action.payload;

        state.requestTxnRejectLoading = false;
        state.requestTxnRejectError = null;
        state.requestTxnRejectData = payload;
      })

      .addCase(requestTxnReject.rejected, (state, action) => {
        state.requestTxnRejectLoading = false;
        state.requestTxnRejectError = action.payload;
      });
    builder.addCase(
      ReimbursementRequestDeniedApproval.pending,
      (state, action) => {
        state.ReimbursementMultiRequestDeniedApprovalLoading = true;
      },
    );
    builder.addCase(
      ReimbursementRequestDeniedApproval.fulfilled,
      (state, action) => {
        state.ReimbursementMultiRequestDeniedApprovalLoading = false;
        state.ReimbursementMultiRequestDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementRequestDeniedApproval.rejected,
      (state, action) => {
        state.ReimbursementMultiRequestWaitingApprovalError = true;
        state.ReimbursementMultiRequestDeniedApprovalData = null;
        state.ReimbursementMultiRequestDeniedApprovalLoading = false;
      },
    );
    builder.addCase(
      ReimbursementRequestWaitingApproval.pending,
      (state, action) => {
        state.ReimbursementMultiRequestDashBoardLoading = true;
      },
    );
    builder.addCase(
      ReimbursementRequestWaitingApproval.fulfilled,
      (state, action) => {
        state.ReimbursementMultiRequestDashBoardLoading = false;
        state.ReimbursementMultiRequestWaitingApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementRequestWaitingApproval.rejected,
      (state, action) => {
        state.ReimbursementMultiRequestWaitingApprovalError = true;
        state.ReimbursementMultiRequestWaitingApprovalData = null;
      },
    );
  },
});

export const {
  setToggle,
  resetToggle,
  setStoredPage,
  resetPage,
  setIsApprovalStatusSelected,
  clearrequestTxnError,
} = reimbursementRequest.actions;

export default reimbursementRequest.reducer;
